import TemplateComponent from "shared/components/template/TemplateComponent";
import { getDisplayNameHelper } from "shared/helpers/profile/getDisplayNameHelper";
import { Tab, Tabs } from "hub/src/components/common/tab";
import { HubReviewsSubmissionPreview } from "hub/src/components/reviews/HubReviewsSubmissionPreview";
import { useHubReviewsVotingPageContext } from "hub/src/context/reviews/HubReviewsVotingPageContext";

export const HubReviewsVotingPageTabs = () => {
  const {
    tabs,
    selectedTab,
    setSelectedTab,
    reviewInstanceAssignment,
    reviewSession,
  } = useHubReviewsVotingPageContext();

  return (
    <div className="mr-3 col-span-4 overflow-y-scroll">
      {tabs && (
        <Tabs
          selectedTab={selectedTab}
          setSelectedTab={(tab) => setSelectedTab(tab)}
        >
          {tabs.map((tab, tabIndex) => {
            if (tab.kind === "child") {
              return (
                <Tab
                  key={`tab-${tabIndex}`}
                  name={`tab-${tabIndex}`}
                  titleText={
                    <TemplateComponent
                      template={tab.child.config.headerTemplate}
                      data={tab.child.templateData}
                    />
                  }
                >
                  <TemplateComponent
                    key={reviewInstanceAssignment.reviewInstanceAssignmentId}
                    className="pb-2"
                    template={tab.child.config.previewTemplate}
                    data={tab.child.templateData}
                  />
                </Tab>
              );
            }

            return (
              <Tab
                key={`tab-${tabIndex}`}
                name={`tab-${tabIndex}`}
                titleText={
                  <TemplateComponent
                    template={reviewSession.tabsTemplate ?? "No Template Found"}
                    data={{
                      name:
                        getDisplayNameHelper(tab.submission.submitterProfile) ??
                        "N/A",
                      role: tab.submission.role,
                      reviewInstanceAssignment,
                      ...tab.submission,
                    }}
                  />
                }
              >
                <HubReviewsSubmissionPreview
                  key={reviewInstanceAssignment.reviewInstanceAssignmentId}
                  {...tab.submission}
                />
              </Tab>
            );
          })}
        </Tabs>
      )}
    </div>
  );
};
